import React, {useEffect, useState} from 'react';
import cx from 'clsx';
import {useCart} from '@montana/containers/cart';
import {SvgIcon} from '../svg-icon';
import {Popup} from '@montana/shared/popup';
import {setGlobalPopupId} from '../popup/popup.helper';
import {useUpdateEffect} from '../update-effect';
import {usePage} from '@montana/containers/page';
import {CartPageKind} from '@montana/pages/dynamic-page.component';
import {MiniCartPopup} from './mini-cart-popup.component';
import {useDynamicSettings} from '@montana/containers/dynamic-settings';

export interface IMiniCartProps {
    timeout?: number;
}

export const MiniCart: React.FC<IMiniCartProps> = (props: IMiniCartProps): JSX.Element => {

    const miniCartId = 'miniCart';
    const {linesToDisplay, updateQuantityLoading, accumulatedQuantity = 0} = useCart();
    const {kind} = usePage();
    const {links} = useDynamicSettings();
    const [disabled, setDisabled] = useState(false);
    const [cartIsActive, setCartIsActive] = useState(false);

    useEffect(() => {
        const cartHasItems = linesToDisplay && linesToDisplay.length;
        const isCartPage = kind === CartPageKind;
        const showCartPopup = cartHasItems && !isCartPage;
        setDisabled(!showCartPopup);
        setCartIsActive(isCartPage);
    }, [kind, linesToDisplay]);

    // Listens for "updateQuantityLoading" to change to false, meaning the cart finished updating, then we open the mini-cart.
    useUpdateEffect(() => {
        if (!updateQuantityLoading && !disabled) {
            // Force mini cart to popup through event via popup helper
            setGlobalPopupId(miniCartId);
        }
    }, [updateQuantityLoading]);

    return (
        <Popup
            id={miniCartId}
            timeout={props.timeout}
            href={links?.cart}
            disabled={disabled}
            className="mini-cart"
            content={
                <MiniCartPopup/>
            }
        >
            <>
                {!!accumulatedQuantity && <span
                    className={cx('mini-cart__counter', accumulatedQuantity > 0 && 'mini-cart__counter--active')}>{accumulatedQuantity}</span>}
                {cartIsActive ? <SvgIcon iconName="bag_active"/> : <SvgIcon iconName="bag_default"/>}
            </>
        </Popup>
    );
};
